/**
 * author: Patrick Vyn Badiang
 */

import { AppBar, Box, Button, SvgIcon, Toolbar } from "@mui/material";
import { ReactComponent as CustomSVG } from '../assets/icons/rocket.svg';

function CustomIcon(props) {
    return <SvgIcon component={CustomSVG} inheritViewBox {...props} />;
}

function MenuBar({ activeSection, setActiveSection }) {
  const navItems = [
    { id: "landing", label: <CustomIcon fontSize="large" /> },
    { id: "about", label: "About" },
    { id: "events", label: "Events" },
    // { id: "photobook", label: "Photobook"},
    { id: "board", label: "Board" },
    { id: "forms", label: "Forms" },
  ];

  // Scroll to a section
  const handleScroll = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      setActiveSection(id);
    }
  };

  return (
    <AppBar position="fixed" color="transparent" elevation={0}>
      <Toolbar>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            gap: 0.5,
          }}
        >
          {navItems.map((item) => (
            <Button
              key={item.id}
              variant={activeSection === item.id ? "outlined" : "text"}
              onClick={() => handleScroll(item.id)}
              sx={{
                borderRadius: "20px",
                color: "primary.main",
                borderColor: "primary.main",
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              {item.label}
            </Button>
          ))}
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default MenuBar;